/* global G */
import { curry } from 'lib/util'
import created from 'model/xEcoApm/collection/created'

/**
 * Returns the date created filtering options.
 *
 * @param module    current module
 * @param component event source
 * @param event     triggered event
 */
const listDateCreated = (
  module: Gaia.AppModule.Spec,
  component: Gaia.Component.Spec,
  event: Gaia.PlatformEvent,
) => {
  return created.map(item => ({
    ...item,
    value: module[G.ADAPTER][G.INTL]._t(
      `filter.created.${item.key}`,
      {
        ns: 'apmGo',
        _key: `filter.created.${item.key}`,
        defaultValue: item.value,
      },
    ),
  }))
}

export default curry(listDateCreated)
